import React from 'react';
import MarkdownViewer from './MarkdownViewer';

function ReviewModerationPolicy() {
  return (
    <MarkdownViewer
      title="Review Moderation Policy"
      fileName="REVIEW_MODERATION_POLICY.md"
    />
  );
}

export default ReviewModerationPolicy;
